import { render } from "./ConcertsSection.vue?vue&type=template&id=da0e7f10&scoped=true"
import script from "./ConcertsSection.vue?vue&type=script&lang=js"
export * from "./ConcertsSection.vue?vue&type=script&lang=js"

import "./ConcertsSection.vue?vue&type=style&index=0&id=da0e7f10&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\User\\OneDrive - Universidad Nacional de Colombia\\Documentos\\Desarrollo\\Tempo\\Front\\Tempo-Front\\tempo-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da0e7f10"]])

export default __exports__